







































































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import { RRule } from 'rrule'
import CalendarService from '@services/CalendarService'
import WeeklyRuleForm, { DEFAULT_WEEKLY_RRULE } from '@ui/Calendar/WeeklyRuleForm'
import MonthlyRuleForm, { DEFAULT_MONTHLY_RRULE } from '@ui/Calendar/MonthlyRuleForm'
import YearlyRuleForm, { DEFAULT_YEARLY_RRULE } from '@ui/Calendar/YearlyRuleForm'
import RepeatUntilRuleForm from '@ui/Calendar/RepeatUntilRuleForm'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'
import CreativeDateVenueBindSelector from '@ui/ResourceBindSelector/CreativeDateVenueBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'AvailabilityCreateStep'

  resources:
    new_calendar_date:
      resourceName: 'calendar_date'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/calendar_dates/new'
      fetch: false

    calendar_date:
      resourceName: 'calendar_date'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/calendar_dates/:calendarDateId/edit'
      fetch: false

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      WeeklyRuleForm,
      MonthlyRuleForm,
      YearlyRuleForm,
      RepeatUntilRuleForm,
      FormFieldRadioButton,
      CreativeDateVenueBindSelector,
      Modal,
    }

    data: ->
      form:
        timeframe: null
        dateRange: []
        startsOn: null
        rrule:
          freq: null
      confirmModal:
        show: false
        navigateOnSave: false

    created: ->
      if @mode is 'edit'
        @fetch 'calendar_date'
      else
        @fetch 'new_calendar_date'

    computed:
      calendarDateId: -> @$route.query.calendarDateId
      calendarDateData: -> @prime.calendar_date || @prime.new_calendar_date
      mode: -> if @calendarDateId then 'edit' else 'new'

      optionsForRecurring: ->
        [
          { value: RRule.WEEKLY, label: 'Repeats Weekly' }
          { value: RRule.MONTHLY, label: 'Repeats Monthly' }
          { value: RRule.YEARLY, label: 'Repeats Annually' }
          { value: null, label: 'Does Not Repeat' }
        ]

      freqIsWeekly: -> @form.rrule?.freq is RRule.WEEKLY
      freqIsMonthly: -> @form.rrule?.freq is RRule.MONTHLY
      freqIsYearly: -> @form.rrule?.freq is RRule.YEARLY
      freqDoesNotRepeat: -> @form.rrule?.freq is null
      isRepeating: -> @form.rrule?.freq isnt null

      timeFrameIsEventDates: -> @form.timeframe is 'event_dates'
      timeFrameIsOngoing: -> @form.timeframe is 'ongoing'

      actionsForDatePickerRange: ->
        onDateRangeBlur: @hiBlurDateRange
        onPickDateRange: @hiPickSingleDate
        onSelectDateRange: @hiSelectDateRange

      actionsForDatePicker: ->
        onDatePickerBlur: @hiBlurDatePicker
        onSelectDatePicker: @hiSelectDatePicker
        onSelectTimeframe: @hiSelectTimeframe

      optionsForBindSelector: ->
        supplierId: @wizard.supplierId

      hasVenues: ->
        @calendarDateData.venue_ids.length > 0

    methods:
      initializeData: ->
        { timeframe, starts_on, ends_on, repeats, rrule_string } = @calendarDateData
        starts_on = dayjs().format(CalendarService.DATE_FORMAT) unless starts_on
        ends_on = starts_on unless ends_on
        @form.timeframe = timeframe
        @form.dateRange = [starts_on, ends_on] if starts_on and ends_on
        @form.startsOn = starts_on if starts_on
        @form.rrule = CalendarService.rruleFromString rrule_string if repeats

      hiSelectFrequency: (freq) ->
        @selectFrequency freq
        @save() if @freqDoesNotRepeat # avoid triggering save twice because it's already called on mount rrule forms

      hiRuleChanged: ->
        @calendarDateData.rrule_string = if @isRepeating then CalendarService.rruleToString @form.rrule else null
        @save()

      hiSelectTimeframe: (timeframe) ->
        @selectTimeframe timeframe
        if timeframe is 'event_dates' and !@calendarDateData.starts_on
          # ongoing got rid of dates, let's reset dates
          today = dayjs().format(CalendarService.DATE_FORMAT)
          @selectDateRange [today, today]
          @initializeData()
        @save()

      hiPickSingleDate: ({ minDate, maxDate }) ->
        return if maxDate
        dateStr = dayjs(minDate).format(CalendarService.DATE_FORMAT)
        @selectDateRange [dateStr, dateStr]
      hiSelectDateRange: (dateRange) ->
        @selectDateRange dateRange
      hiBlurDateRange: ->
        @initializeData() # reset form with fresher data
        @save()

      hiSelectDatePicker: (startsOn) ->
        @selectDateRange [startsOn, startsOn]
      hiBlurDatePicker: ->
        @initializeData() # reset form with fresher data
        @save()

      hiSaveAndNavigate: ->
        @confirmModal.navigateOnSave = true
        @save()

      selectTimeframe: (timeframe) ->
        @calendarDateData.timeframe = timeframe

      selectFrequency: (freq) ->
        rruleByFreq =
          [RRule.WEEKLY]: { ...DEFAULT_WEEKLY_RRULE }
          [RRule.MONTHLY]: { ...DEFAULT_MONTHLY_RRULE }
          [RRule.YEARLY]: { ...DEFAULT_YEARLY_RRULE }
          [null]: { freq: null}
        rrule = rruleByFreq[freq]
        @calendarDateData.repeats = freq?
        @calendarDateData.rrule_string = if freq? then CalendarService.rruleToString rrule else null
        @calendarDateData.timeframe = if freq is RRule.WEEKLY then 'ongoing' else 'event_dates'
        @initializeData() # reset form with fresher data

      selectDateRange: (dateRange) ->
        [startsOn, endsOn] = dateRange
        @calendarDateData.starts_on = startsOn
        @calendarDateData.ends_on = endsOn

      save: ->
        resourceKey = 'prime.calendar_date' if @mode is 'edit'
        resourceKey ||= 'prime.new_calendar_date'
        @saveItem resourceKey, null, { skipFlash: true }

      onSave: (item) ->
        @wizard.back({ skipSave: true }) if @confirmModal.navigateOnSave
        return if @mode is 'edit'
        @$router.replace { query: { ...@$route.query, calendarDateId: item.id } }
        @fetchCalendarDate()

      fetchCalendarDate: ->
        @fetch 'calendar_date'

      hiEditVenue: (venue) ->
        @wizard.navToStepName 'venue-edit'
        @$router.replace { query: { ...@$route.query, venueId: venue.id }}

    watch:
      calendarDateData: (newData, oldData) ->
        @initializeData() unless oldData

      requestIsPending: (value) ->
        @wizard.hideWaitingModal() unless value

export default VueOptions.vue settings
